package com.dignicate.web.data.markdown.parser.handlers

import com.dignicate.web.data.markdown.parser.core.MarkdownHandler
import com.dignicate.web.data.markdown.parser.core.ParsingContext

class BlankLineHandler : MarkdownHandler {
    override fun canHandle(ctx: ParsingContext): Boolean {
        return ctx.currentLine()?.isBlank() == true
    }

    override fun handle(ctx: ParsingContext) {
        ctx.index++
    }
}
